export const language: any = {
  title: 'วัตถุดิบ',
  select_all: 'เลือกทั้งหมด',
  deselect_all: 'ยกเลิกการเลือกทั้งหมด',
  add: 'เพิ่มวัตถุดิบ',
  add_title: 'กรุณาเลือกวิธีการเพิ่มวัตถุดิบ',
  add_by_list: 'เพิ่มวัตถุดิบ',
  add_total: 'เพิ่มวัตถุดิบทั้งหมด {number} รายการ',
  selecting: 'รวมวัตถุดิบ',
  filter_title: 'จัดเรียงการเลือก',
  filter_newest: 'ล่าสุด',
  filter_oldest: 'เก่าที่สุด',
  filter_alphabet: 'ตามลำดับตัวอักษร',
  get_recipe: 'รับคำแนะนำการทำอาหารจาก AI',
  search_placeholder: 'กรุณาป้อนคำค้นหาของคุณ',
  nodata: 'ไม่มีวัตถุดิบ',
  request: 'เพิ่มวัตถุดิบ',
  recipe_title: 'จานอาหารที่แนะนำ',
  option: {
    title: 'เลือกตัวเลือก',
    desc: 'การเลือกตัวเลือกไม่จำเป็นต้องทำ',
    complete: 'เสร็จสิ้น',
    reset: 'รีเซ็ต',
  },
  msg: {
    msg_7: "คุณต้องการเพิ่มวัตถุดิบที่เลือกไหม?",
    msg_8: `
      <p>คุณต้องการเพิ่มวัตถุดิบที่เลือกไหม?</p>
      <p class="text-[11px] font-normal">(<span class="text-primary">{name}</span> ถูกยกเว้นเนื่องจากมันรวมอยู่ในวัตถุดิบของอาหารที่มีอยู่แล้ว)</p>
    `,
    msg_9: "คุณต้องการเพิ่มวัตถุดิบที่เลือกไปยังตะกร้าของคุณไหม?",
    msg_10: `
      <p>คุณต้องการเพิ่มวัตถุดิบที่เลือกไปยังตะกร้าของคุณไหม?<br />
      <p class="text-[11px] font-normal">(<span class="text-primary">{name}</span> ถูกยกเว้นเนื่องจากมันรวมอยู่ในวัตถุดิบของอาหารที่มีอยู่แล้ว)</p>
    `,
    confirm: 'เพิ่ม',
    cancel: 'ยกเลิก',
    not_ingredient: 'ข้อมูลที่คุณป้อนไม่ใช่ส่วนผสม.<br />กรุณาตรวจสอบอีกครั้ง.',
    ai_failed: 'เกิดข้อผิดพลาดในการป้อนส่วนผสม.<br />กรุณาลองใหม่อีกครั้ง.',
    ingredient_exist_should_exclued: `(<span class="text-primary">{name}</span> ถูกยกเว้นเนื่องจากมันรวมอยู่ในวัตถุดิบของอาหารที่มีอยู่แล้ว)`
  },
  history: "ประวัติการวิเคราะห์ภาพ",
  myIngredient: "ส่วนผสมของฉัน",
  history_no_data: "ไม่มีประวัติ",
  history_take_photo: "ถ่ายหรือเลือกรูปภาพ",
}
